import React from 'react';

function iconProps(className) {
  return {
    'aria-hidden': 'true',
    className,
    fill: 'currentColor',
    viewBox: '0 0 24 24',
  };
}

export function SpotifyIcon({ className = 'h-6 w-6' }) {
  return (
    <svg {...iconProps(className)}>
      <path d="M12 1.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Zm4.817 15.145a.654.654 0 0 1-.9.216c-2.47-1.508-5.579-1.85-9.239-1.018a.653.653 0 1 1-.289-1.274c4.005-.91 7.45-.518 10.21 1.168.308.188.405.591.218.908Zm1.286-2.862a.816.816 0 0 1-1.122.27c-2.828-1.738-7.139-2.242-10.482-1.225a.816.816 0 1 1-.475-1.56c3.807-1.16 8.539-.594 11.812 1.417.385.237.505.739.267 1.098Zm.11-2.98C14.83 8.79 9.251 8.605 6.022 9.584a.98.98 0 1 1-.568-1.876c3.708-1.126 9.883-.907 13.787 1.412a.98.98 0 0 1-1.028 1.684Z" />
    </svg>
  );
}

export function YouTubeIcon({ className = 'h-6 w-6' }) {
  return (
    <svg {...iconProps(className)}>
      <path d="M23.498 6.186a2.997 2.997 0 0 0-2.112-2.122C19.522 3.5 12 3.5 12 3.5s-7.522 0-9.386.564A2.997 2.997 0 0 0 .502 6.186 31.214 31.214 0 0 0 0 12a31.214 31.214 0 0 0 .502 5.814 2.997 2.997 0 0 0 2.112 2.122C4.478 20.5 12 20.5 12 20.5s7.522 0 9.386-.564a2.997 2.997 0 0 0 2.112-2.122A31.214 31.214 0 0 0 24 12a31.214 31.214 0 0 0-.502-5.814ZM9.6 15.568V8.432L15.818 12 9.6 15.568Z" />
    </svg>
  );
}

export function TikTokIcon({ className = 'h-6 w-6' }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="currentColor"
      viewBox="0 0 32 32"
    >
      <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z" />
    </svg>
  );
}
